import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetProductComponent } from './widget-product.component';
import { CarouselModule } from 'primeng/carousel';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    WidgetProductComponent
  ],
  imports: [
    CommonModule,
    CarouselModule,
    RouterModule,
    ButtonModule
  ],
  exports: [
    WidgetProductComponent
  ]
})
export class WidgetProductModule { }
